/* eslint-disable no-unused-vars, no-console */
import React, { Component } from 'react';
import { object, bool, string, func } from 'prop-types';
import { Button, ButtonGroup } from '../../../../ps-aspect-design';
import { withRouter } from 'react-router';
import Input from 'ps-components/Input/Input';
import { Modal } from 'ps-design';

import { longDateString } from '../../../lib/formatters';
import InPlaceIndicator from '../../../LoadingIndicator/InPlaceIndicator/InPlaceIndicator';
import './VisualizationSlideOut.scss';
class VisualizationSlideOut extends Component {
  static propTypes = {
    deleteReport: func,
    getReportEditable: func,
    hideSlideout: func,
    history: object,
    location: object,
    newReportId: string,
    report: object,
    reportDeleteError: string,
    reportSaveError: string,
    reportWriterUrl: string,
    saveReportAs: func,
    reportCloneLoading: bool,
    reportDeleteLoading: bool,
    refresh: func
  };

  constructor(props) {
    super(props);

    this.closePanel = this.closePanel.bind(this);
    this.viewReportClick = this.viewReportClick.bind(this);
    this.confirmDeleteReport = this.confirmDeleteReport.bind(this);
    this.confirmSaveAs = this.confirmSaveAs.bind(this);
    this.showSaveAsModal = this.showSaveAsModal.bind(this);
    this.showDeleteModal = this.showDeleteModal.bind(this);
    this.hideDeleteModal = this.hideDeleteModal.bind(this);
    this.hideSaveAsModal = this.hideSaveAsModal.bind(this);
    this.reportNameChanged = this.reportNameChanged.bind(this);
    this.reportNameValid = this.reportNameValid.bind(this);
    this.viewVisualizationClick = this.viewVisualizationClick.bind(this);

    this.state = {
      containerHeight: 0,
      containerWidth: 0,
      reportId: 0
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.report?.id && nextProps.report?.id !== this.props.report?.id) {
      this.props.getReportEditable(nextProps.report?.id);
    }
  }

  closePanel() {}

  showSaveAsModal() {
    this.saveAsModal.show();
  }

  hideSaveAsModal() {
    this.saveAsModal.hide();
  }

  showDeleteModal() {
    this.deleteModal.show();
  }

  hideDeleteModal() {
    this.deleteModal.hide();
  }

  viewReportClick() {
    const url = this.props.reportWriterUrl + '/' + this.props.report?.id;
    this.viewUrl(url);
  }

  viewVisualizationClick() {
    const url = this.getUrlForViz();
    this.viewUrl(url);
  }

  getUrlForViz() {
    const encodedEmbedUrl = encodeURIComponent(this.props.report?.url).replace(/\./g, '%2E');
    return `${this.props.reportWriterUrl}/${this.props.report?.id}/sheet/workbook/${encodedEmbedUrl}`;
  }

  viewUrl(url) {
    this.props.history.push({
      pathname: url,
      state: { history: this.props.location.pathname }
    });
    this.props.hideSlideout();
  }

  confirmDeleteReport() {
    this.props.deleteReport(this.props.report?.id).then(success => {
      if (success) {
        let url = '/reports/library';
        this.props.history.push({
          pathname: url,
          state: { history: this.props.location.pathname }
        });

        this.hideDeleteModal();
        this.props.hideSlideout();
        this.props.refresh();
      }
    });
  }

  reportNameChanged(event) {
    this.setState({
      reportName: event.target.value
    });
  }

  reportNameValid() {
    if (this.state.reportName && this.state.reportName.length > 2) {
      this.setState({
        reportNameError: null
      });
      return true;
    } else {
      this.setState({
        reportNameError: 'New report name must have at least two characters'
      });
      return false;
    }
  }

  confirmSaveAs() {
    if (this.reportNameValid()) {
      this.props
        .saveReportAs(this.props.report?.id, this.state.reportName, this.props.report?.type?.id)
        .then(success => {
          if (success) {
            let url = this.props.reportWriterUrl + '/' + this.props.newReportId;
            this.props.history.push({
              pathname: url,
              state: { history: this.props.location.pathname }
            });

            this.hideSaveAsModal();
            this.props.hideSlideout();
          }
        });
    }
  }

  renderVizContainer() {
    return (
      <div
        className="contents__container"
        key={this.state.reportId}
        ref={vizContainerElement => (this.vizContainerElement = vizContainerElement)}
      />
    );
  }

  render() {
    const thumbnail = this.props.report?.thumbnail || '../images/defaultVisualization.png';
    const canEditReport = this.props.report?.isEditable || false;

    if (!this.props.report) {
      return <InPlaceIndicator />;
    }

    return (
      <div className="slideout__visualization">
        <div className="contents__header">
          <div className="contents__header-actions">
            <button onClick={this.showSaveAsModal}>
              <i className="icon-floppy" />
              Save As
            </button>
            {canEditReport && (
              <button onClick={this.showDeleteModal}>
                <i className="icon-trash" />
                Delete
              </button>
            )}
            <button className="contents__header-close" onClick={this.props.hideSlideout}>
              <i className="icon-cancel" />
            </button>
          </div>
          <div className="contents__header-title">
            <div className="titleDetails">
              <h4>{this.props.report?.name}</h4>
              <span className="contents__header--details">
                Last modified {longDateString(new Date(this.props.report?.lastModified))} -{' '}
                {this.props.report?.lastModifiedBy.firstName} {this.props.report?.lastModifiedBy.lastName}
              </span>
            </div>
            <div className="titleAction">
              <button className="pxl-btn pxl-btn-primary" onClick={this.viewReportClick}>
                View Report
              </button>
            </div>
          </div>
        </div>
        <div className="contents__container" key={this.state.reportId}>
          <img src={thumbnail} alt="visualization" />
          <div className="contents__overlay">
            <button className="pxl-btn pxl-btn-secondary" onClick={this.viewVisualizationClick}>
              View Visualization
            </button>
          </div>
        </div>
        <div className="contents__details">
          <div className="contents__details-description">
            <h4>Description</h4>
            <span>{this.props.report?.description}</span>
          </div>
        </div>
        <Modal
          ref={saveAsModal => {
            this.saveAsModal = saveAsModal;
          }}
          id="saveAsModal"
          className="modal__saveas"
          displayCloseButton={true}
        >
          <div className="modal__saveas-contents">
            <div className="modal__saveas-name">
              <div className="modal__new-report-name">Enter New Report Name:</div>
              <Input className="modal__new-report-name-input" id="reportName" onChange={this.reportNameChanged} />
            </div>
            <div className="modal__saveas-actions">
              <ButtonGroup>
                {this.props.reportDeleteLoading ? (
                  <InPlaceIndicator />
                ) : (
                  <>
                    <Button variant="secondary" onClick={this.hideSaveAsModal}>
                      Cancel
                    </Button>
                    <Button variant="primary" onClick={this.confirmSaveAs}>
                      Save
                    </Button>
                  </>
                )}
              </ButtonGroup>
            </div>
          </div>
        </Modal>
        <Modal
          ref={deleteModal => {
            this.deleteModal = deleteModal;
          }}
          id="deleteModal"
          className="modal__delete"
          displayCloseButton={true}
        >
          <div className="modal__delete-contents">
            <div className="modal__delete-title">Are you sure you want to delete this report?</div>
            <div className="modal__delete-actions">
              <ButtonGroup>
                {this.props.reportCloneLoading ? (
                  <InPlaceIndicator />
                ) : (
                  <>
                    <Button variant="secondary" onClick={this.hideDeleteModal}>
                      No
                    </Button>
                    <Button variant="primary" onClick={this.confirmDeleteReport}>
                      Yes
                    </Button>
                  </>
                )}
              </ButtonGroup>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default withRouter(VisualizationSlideOut);
